import axiosInstance from "../../api/axiosInstance";

let uploadspacemasive = (form) => {
    return new Promise((resolve, reject) => { 
        axiosInstance.post(process.env.REACT_APP_API + "/espacios/carga-masiva", form).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

let uploadmeasuremasive = (form) => {
    return new Promise((resolve, reject) => { 
        axiosInstance.post(process.env.REACT_APP_API + "/medidas/medidas/carga-masiva", form).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export {
    uploadspacemasive,
    uploadmeasuremasive
}